import React from 'react'
import { Space } from '../../layouts'
import { P, H3 } from '../StyledText'
import { ICreated } from '../../types/date'
import * as date from '../../services/date'

export const CreatedItem = ({ created, createdBy }: ICreated) => (
  <>
    <Space mb={4}>
      <H3 mb={2}>Created</H3>
      <P>{date.calendar(created, 'SHORT')}</P>
    </Space>
    <Space mb={4}>
      <H3 mb={2}>Created by</H3>
      <P>{createdBy.name}</P>
    </Space>
  </>
)
